import { Link } from "react-router-dom";

const TableActionLink = ({
  icon,
  label,
  to,
  disabled,
  className,
}: {
  icon: React.ReactNode;
  label: string;
  to: string;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <Link to={disabled ? "#" : to} className={"group relative " + className}>
      {icon}
      <div className="border border-gray-200 dark:border-gray-600 absolute right-full top-1/2 -translate-y-1/2 mr-2 w-48 p-2 bg-gray-800 text-white text-xs rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
        {label}
      </div>
    </Link>
  );
};

export default TableActionLink;
